export const minifyJSON = (inputData) => {
  try {
    return { minified: JSON.stringify(JSON.parse(inputData), null, 0), isError: false };
  } catch (error) {
    return { minified: 'Error: Invalid JSON input.', isError: true };
  }
};

export const minifyXML = (inputData) => {
  try {
    return { minified: inputData.replace(/\s+/g, ' ').trim(), isError: false };
  } catch (error) {
    return { minified: 'Error: Invalid XML input.', isError: true };
  }
};

export const minifyHTML = (inputData) => {
  try {
    return { minified: inputData.replace(/\s+/g, ' ').trim(), isError: false };
  } catch (error) {
    return { minified: 'Error: Invalid HTML input.', isError: true };
  }
};

export const minifyCSS = (inputData) => {
    try {
        const minified = inputData
            .replace(/\/\*[\s\S]*?\*\//g, '')     
            .replace(/\s*{\s*/g, '{')
            .replace(/\s*}\s*/g, '}')
            .replace(/\s*;\s*/g, ';')
            .replace(/\s*:\s*/g, ':')
            .replace(/\s*,\s*/g, ',')
            .replace(/\s+/g, ' ')                 
            .replace(/\n/g, '')                   
            .trim();
        return { minified, isError: false };
    } catch (error) {
        return { minified: 'Error: Invalid CSS input.', isError: true };
    }
};

export const minifyJs = (inputData) => {
  try {
    const minified = inputData
      .replace(/\/\/.*(?=[\n\r])/g, '')            
      .replace(/\/\*[\s\S]*?\*\//g, '')            
      .replace(/\s*([{};:,+<>=!&|()\[\]])\s*/g, '$1') 
      .replace(/\n+/g, '')                         
      .replace(/\s{2,}/g, ' ')                     
      .trim();
    return { minified, isError: false };
  } catch (error) {
    return { minified: 'Error: Invalid JavaScript input.', isError: true };
  }
};
